
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { TimeAccountMonthly, TimeAccountWeekly } from '@/services/api/nswag/stapiclient_generated';

@Component({
  components: {},
})
export default class TimeAccountSumCell extends Vue {
  @Prop() data!: TimeAccountMonthly | TimeAccountWeekly;
  @Prop({ default: true }) displayDetails!: boolean;
}
